import api from '@/apis/ca/cAPaymentDetailAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('cAPaymentDetail', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ca_payment_detail',
    field: {
      key: 'ref_detail_id',
      // code: 'ref_no'
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
